import { render, staticRenderFns } from "./StatusMessage.vue?vue&type=template&id=85a36170&scoped=true&"
import script from "./StatusMessage.vue?vue&type=script&lang=js&"
export * from "./StatusMessage.vue?vue&type=script&lang=js&"
import style0 from "./StatusMessage.vue?vue&type=style&index=0&id=85a36170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a36170",
  null
  
)

export default component.exports